"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _components = require("./components");

var _core = require("@emotion/core");

const Button = props => {
  const {
    component,
    ref,
    className,
    children,
    variant,
    'data-testid': dataTestId,
    alignment,
    hasOnlyIcon,
    size,
    ...other
  } = props;
  return (0, _core.jsx)(_components.Button, (0, _extends2.default)({
    as: component,
    ref: ref,
    className: className,
    "data-testid": dataTestId,
    variant: variant,
    alignment: alignment,
    hasOnlyIcon: hasOnlyIcon,
    size: size
  }, other), children);
};

exports.Button = Button;
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  variant: (0, _propTypes.oneOf)(['primary', 'transparent']),
  alignment: (0, _propTypes.oneOf)(['center', 'space-between']),
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),
  hasOnlyIcon: _propTypes.bool,
  'data-testid': _propTypes.string,
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  ref: (0, _propTypes.shape)({
    current: _propTypes.elementType
  }),
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.object, _propTypes.string]).isRequired
} : void 0;
Button.defaultProps = {
  variant: 'primary',
  alignment: 'center',
  component: 'button',
  hasOnlyIcon: false,
  size: 'medium'
};
Button.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Button",
  "props": {
    "variant": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'transparent'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "alignment": {
      "defaultValue": {
        "value": "'center'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'center'",
          "computed": false
        }, {
          "value": "'space-between'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "component": {
      "defaultValue": {
        "value": "'button'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "elementType"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": ""
    },
    "hasOnlyIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "'medium'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "data-testid": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "ref": {
      "type": {
        "name": "shape",
        "value": {
          "current": {
            "name": "elementType",
            "required": false
          }
        }
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "elementType"
        }, {
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": true,
      "description": ""
    }
  }
};